import { DashboardTask } from './queries';
import { DashboardProjectContext } from './projectContextQueries';

export const getTaskColumn = ({
  task,
  projectContext
}: {
  task: DashboardTask;
  projectContext: DashboardProjectContext | null;
}) => {
  const columns = (projectContext?.columns || []).map(column => ({
    ...column,
    id: Number(column.id),
    projectId: Number(column.projectId),
    columnId: Number(column.id),
    position: Number(column.position || 0),
    isComplete: !!column.complete,
    statusId: column.statusId ? Number(column.statusId) : null
  }));

  if (task.column) {
    return {
      ...task.column,
      id: Number(task.column.id),
      projectId: Number(task.project.id),
      columnId: Number(task.column.id),
      position: Number(task.column.position || 0),
      isComplete: !!task.column.complete,
      statusId: task.column.statusId ? Number(task.column.statusId) : null
    };
  }

  return {
    id: null,
    columnId: null,
    name: task.statusName,
    position: task.statusId
      ? columns.map(({ position }) => position).sort((a, b) => b - a)[0] + 1
      : 0,
    statusId: task.statusId ? Number(task.statusId) : null,
    isComplete: false,
    projectId: Number(task.project.id)
  };
};
